import _ from 'lodash';

const LOWERCASE_ALPHABET = 'abcdefghijklmnopqrstuvwxyz'.split('');

export const indexToChar = _.memoize(index => {
  return LOWERCASE_ALPHABET[index % LOWERCASE_ALPHABET.length];
});
